module.exports = __webpack_public_path__ + "img/tn-timeline-main-2.4dd0e4b3.jpg";